module.exports = __webpack_public_path__ + "img/junfei1.f2037830.png";